(function() {
    angular.module("cstudioApp.services").factory('genreData', function(){
    return [{
                ID: "0000000001",
                Name: "Crime",
                NameTranslations: [],
                Description: "Crime",
                DescriptionTranslations: []
            },
            {
                ID: "0000000002",
                Name: "Fantasy",
                NameTranslations: [],
                Description: "Fantasy",
                DescriptionTranslations: []
            },
            {
                ID: "0000000003",
                Name: "History",
                NameTranslations: [],
                Description: "History",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000001",
                Name: "Comedy",
                NameTranslations: [],
                Description: "Comedy",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000002",
                Name: "Drama",
                NameTranslations: [],
                Description: "Drama",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000003",
                Name: "Horror",
                NameTranslations: [],
                Description: "Horror",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000004",
                Name: "Thriller",
                NameTranslations: [],
                Description: "Thriller",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000005",
                Name: "Documentary",
                NameTranslations: [],
                Description: "Documentary",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000006",
                Name: "Family",
                NameTranslations: [],
                Description: "Family/Children",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000007",
                Name: "Science Fiction",
                NameTranslations: [],
                Description: "Sci Fi/Fantasy",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000008",
                Name: "Childrens",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000009",
                Name: "Western",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000010",
                Name: "Action",
                NameTranslations: [],
                Description: "Action/Adventure",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000011",
                Name: "Adventure",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000012",
                Name: "Romance",
                NameTranslations: [],
                Description: "Romance",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000013",
                Name: "Musical",
                NameTranslations: [],
                Description: "Musical",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000014",
                Name: "War",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000015",
                Name: "Test",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000016",
                Name: "Outtakes Festival",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000017",
                Name: "Animated",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000018",
                Name: "Teen",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000019",
                Name: "Fantasy",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000020",
                Name: "Live Sport Broadcast",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000021",
                Name: "Indian",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000022",
                Name: "Festival",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000023",
                Name: "Foreign",
                NameTranslations: [],
                Description: "Foreign",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000024",
                Name: "Martial Arts",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000025",
                Name: "Concert",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000026",
                Name: "Biography",
                NameTranslations: [],
                Description: "Biography",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000027",
                Name: "Period Drama",
                NameTranslations: [],
                Description: "Period Drama",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000028",
                Name: "Cinema Asia",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000029",
                Name: "3D",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            },
            {
                ID: "HO00000030",
                Name: "IMAX",
                NameTranslations: [],
                Description: "",
                DescriptionTranslations: []
            }
        ];
        
    });
})();


// (function() {
//     angular.module("cstudioApp.services").factory("genreData", function() {
//         return [{
//                 ID: "0000000001",
//                 Name: "Crime",
//                 NameTranslations: [],
//                 Description: "Crime",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "0000000002",
//                 Name: "Fantasy",
//                 NameTranslations: [],
//                 Description: "Fantasy",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "0000000003",
//                 Name: "History",
//                 NameTranslations: [],
//                 Description: "History",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000001",
//                 Name: "Comedy",
//                 NameTranslations: [],
//                 Description: "Comedy",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000002",
//                 Name: "Drama",
//                 NameTranslations: [],
//                 Description: "Drama",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000003",
//                 Name: "Horror",
//                 NameTranslations: [],
//                 Description: "Horror",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000004",
//                 Name: "Thriller",
//                 NameTranslations: [],
//                 Description: "Thriller",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000005",
//                 Name: "Documentary",
//                 NameTranslations: [],
//                 Description: "Documentary",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000006",
//                 Name: "Family",
//                 NameTranslations: [],
//                 Description: "Family/Children",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000007",
//                 Name: "Science Fiction",
//                 NameTranslations: [],
//                 Description: "Sci Fi/Fantasy",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000008",
//                 Name: "Childrens",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000009",
//                 Name: "Western",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000010",
//                 Name: "Action",
//                 NameTranslations: [],
//                 Description: "Action/Adventure",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000011",
//                 Name: "Adventure",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000012",
//                 Name: "Romance",
//                 NameTranslations: [],
//                 Description: "Romance",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000013",
//                 Name: "Musical",
//                 NameTranslations: [],
//                 Description: "Musical",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000014",
//                 Name: "War",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000015",
//                 Name: "Test",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000016",
//                 Name: "Outtakes Festival",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000017",
//                 Name: "Animated",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000018",
//                 Name: "Teen",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000019",
//                 Name: "Fantasy",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000020",
//                 Name: "Live Sport Broadcast",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000021",
//                 Name: "Indian",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000022",
//                 Name: "Festival",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000023",
//                 Name: "Foreign",
//                 NameTranslations: [],
//                 Description: "Foreign",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000024",
//                 Name: "Martial Arts",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000025",
//                 Name: "Concert",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000026",
//                 Name: "Biography",
//                 NameTranslations: [],
//                 Description: "Biography",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000027",
//                 Name: "Period Drama",
//                 NameTranslations: [],
//                 Description: "Period Drama",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000028",
//                 Name: "Cinema Asia",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000029",
//                 Name: "3D",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             },
//             {
//                 ID: "HO00000030",
//                 Name: "IMAX",
//                 NameTranslations: [],
//                 Description: "",
//                 DescriptionTranslations: []
//             }
//         ];
//     });
// })();
